export default __webpack_public_path__ + "static/media/Project3.67464544.jpg";